module.exports = __webpack_public_path__ + "static/amazon_workspaces-4c606eba6304abdf8549352cb436065a.svg";